import { colors } from './colors.theme'

const textColors = Object.fromEntries(
  Object.entries(colors).map(([key, val]) => {
    return [
      [`&.${key}`],
      {
        color: val,
      },
    ]
  }),
)

export const typographyTheme = {
  root: {
    ...textColors,
  },
  h1: {
    fontWeight: 700,
    fontSize: 32,
  },
}
